import styled, { css } from 'styled-components';

// Import components
import { LazyImage } from '../../atoms/LazyImage';

// Import styles
import { flex, customMinResponsive, size } from 'components/styles';

export const List = styled.ul`
	list-style: none;
	padding: 1.6rem;
	background-color: #0d0f13;
	display: grid;
	grid-template-columns: repeat(4, 8rem);
	gap: 0.5rem;
	border-radius: 2rem;

	${customMinResponsive(
		size.semi,
		css`
			grid-template-columns: repeat(9, 8rem);
		`
	)}
`;

export const ListItem = styled.li`
	${flex()}
	padding: 15%;
	border: 1px solid #2a2c2f;
	border-radius: 30%;
	aspect-ratio: 1/1;
`;

export const Image = styled(LazyImage)`
	width: 100%;
	object-fit: contain;
	object-position: center;
	height: 100%;
`;
